import { useEffect, useState } from 'react';
import { gql, useLazyQuery, useApolloClient } from '@apollo/client';
import { getOfferDetails, getOfferDetailsVariables } from './__queries__';
import OfferDialog from '../../../Scenes/Home/Components/OfferDialog';
import { useSelector } from 'Hooks';

const GET_OFFER_DETAILS = gql`
  query getOfferDetails($id: ID!) {
    offer: Offer(id: $id) {
      id
      createdAt
      type
      discountRate
      discountType
      price
      nameLang {
        id
        se
        en
        no
        es
      }
      descriptionLang {
        id
        se
        en
        no
        es
      }
      venues {
        id
      }
      image {
        id
        file {
          id
          url
        }
      }
    }
  }
`;

type Props = {
  onReady: () => void;
};

const OfferToken = ({ onReady }: Props) => {
  const user = useSelector((state) => state.user);
  const [offerId, setOfferId] = useState<string | undefined>(undefined);
  const [tokenId, setTokenId] = useState<string | undefined>(undefined);
  const client = useApolloClient();

  const [getOffer, { data: dataOffer }] = useLazyQuery<getOfferDetails, getOfferDetailsVariables>(
    GET_OFFER_DETAILS,
  );

  useEffect(() => {
    onReady();
  }, []);

  const clearOffer = () => {
    setOfferId(undefined);
    setTokenId(undefined);
  };

  const onMessage = (msg: any) => {
    let data = msg?.data;

    try {
      data = typeof data === 'string' ? JSON.parse(data) : data;
    } catch (e) {
      console.error(e);
      return;
    }

    if (data?.offerId) {
      setOfferId(data.offerId);
    }

    if (data?.tokenId) {
      setTokenId(data.tokenId);
    }
  };

  // handle message
  useEffect(() => {
    if (!user || !offerId) {
      return;
    }

    getOffer({
      variables: {
        id: offerId,
      },
    });
  }, [user, offerId]);

  useEffect(() => {
    // Add the event listener for messages passed from app wrapper
    document.addEventListener('message', onMessage);
    window.addEventListener('message', onMessage);

    // To prevent memory leaks, remove all event listeners on demount
    return () => {
      document.removeEventListener('message', onMessage);
      window.removeEventListener('message', onMessage);
    };
  }, []);

  const lightOfferData = client.readFragment({
    id: offerId,
    fragment: gql`
      fragment currentOffer on Offer {
        id
        createdAt
        type
        discountRate
        discountType
        price
        nameLang {
          id
          se
          en
          no
          es
        }
        descriptionLang {
          id
          se
          en
          no
          es
        }
        venues {
          id
        }
        image {
          id
          file {
            id
            url
          }
        }
      }
    `,
  });

  const offer = offerId ? dataOffer?.offer || lightOfferData : null;
  if (!offer) {
    return null;
  }

  if (Object.keys(offer).length === 0) {
    return null;
  }
  return <OfferDialog activeOffer={offer} onClose={clearOffer} />;
};

export default OfferToken;
